import { CommunityMainServiceType } from '@/js/utils/communityMainService'
export const FeeGetConfig = state => { return state.fee }

/**
 * 「響應式地」確認指定的服務是否啟用。
 * @param {Object} state - Vuex 的狀態對象。
 * @returns {Boolean} 返回布林值，表示服務是否啟用。
 * @param {string} serviceId - 要檢查的服務 ID。
 */
export const isServiceEnabled = (state) => (serviceId) => {
  return !!state.localStorage.communityMainService?.find(
    el => el.CommunityMainServiceType === CommunityMainServiceType.Plugin &&
          el.Id === serviceId
  )
}
